<ng-container *ngIf="!selectedOnly">
  <div class="filters-inner">
    <div class="h3" *ngIf="!filterSelected" i18n="@@RefineYourSearch">Affiner votre recherche :</div>
    <div class="h3" *ngIf="filterSelected">{{ filterSelected.name }}</div>
    <div class="filters-selectors">
      <ng-container *ngTemplateOutlet="filtersSelected"></ng-container>
      <div class="filters-selectors-inner" *ngIf="predicate.ids && filtersTree && filtersTree?.CriteriaTrees && filtersTree?.CriteriaTrees?.length">
        <div class="filters" *ngIf="filtersTree.CriteriaTrees">
          <div class="filter-single">
            <app-custom-toggle [init]="false" (activeChange)="onGeolocationActiveChange($event)"></app-custom-toggle>
            <div class="filter-single-title" i18n="@@AroundMe">Autour de moi</div>

          </div>
          <div class="filter-single">
            <app-custom-toggle [init]="predicate.ids.includes('sur-place.tourisme-handicap.deficience-motrice')" (activeChange)="toggleFilter($event,'sur-place.tourisme-handicap.deficience-motrice')"></app-custom-toggle>
            <div class="filter-single-title" i18n="@@HandicapPMR">Handicap / PMR</div>
          </div>
        </div>
        <div class="filters" *ngIf="filtersTree.CriteriaTrees">
          <ng-container *ngFor="let filter of filtersTree.CriteriaTrees">
            <div class="filters-list" *ngIf="filter.ObjectCount>0 || filter.Children.length>0">
              <div class="filter-title" (click)="addFilter(filter)">
                {{filter.name}} <span *ngIf="filter.ObjectCount>0">({{filter.ObjectCount}})</span>
              </div>
              <ng-container *ngTemplateOutlet="currentFilter; context:{$implicit: filter}"></ng-container>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="filters-footer">
        <button class="button" (click)="filterSelected = null;modal.close()" i18n="@@Validate">Valider</button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="selectedOnly">
  <ng-container *ngTemplateOutlet="filtersSelected"></ng-container>
</ng-container>

<ng-template #filtersSelected>
  <div class="filters-selected" [ngClass]="{'filters-selected-only':selectedOnly}" *ngIf="filtersTree?.CriteriaTrees">
    <ng-container *ngFor="let filter of filtersTree.CriteriaTrees">
      <ng-container *ngTemplateOutlet="filterButtonRemoveTemplate; context:{$implicit: filter}"></ng-container>
      <ng-container *ngFor="let subFilter of filter.Children">
        <ng-container *ngTemplateOutlet="filterButtonRemoveTemplate; context:{$implicit: subFilter}"></ng-container>
        <ng-container *ngFor="let sub2Filter of subFilter.Children">
          <ng-container *ngTemplateOutlet="filterButtonRemoveTemplate; context:{$implicit: sub2Filter}"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #filterButtonAddTemplate let-filter>
  <div class="filter-button filter-add" (click)="addFilter(filter);" *ngIf="!predicate.ids.includes(filter.id) && filtersTree.CriteriaTrees|treeSearch:filter.id">
    {{filter.name}} <span *ngIf="filter.ObjectCount>0">{{filter.ObjectCount}}</span>
  </div>
</ng-template>
<ng-template #filterButtonRemoveTemplate let-filter>
  <div class="filter-button filter-removable" *ngIf="predicate.ids.includes(filter.id)" (click)="removeFilter(filter)">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.0672 15.1832C16.1252 15.2412 16.1713 15.3102 16.2027 15.386C16.2342 15.4619 16.2503 15.5432 16.2503 15.6253C16.2503 15.7075 16.2342 15.7888 16.2027 15.8647C16.1713 15.9405 16.1252 16.0095 16.0672 16.0675C16.0091 16.1256 15.9402 16.1717 15.8643 16.2031C15.7884 16.2345 15.7071 16.2507 15.625 16.2507C15.5429 16.2507 15.4615 16.2345 15.3857 16.2031C15.3098 16.1717 15.2409 16.1256 15.1828 16.0675L9.99998 10.8839L4.81717 16.0675C4.69989 16.1848 4.54083 16.2507 4.37498 16.2507C4.20913 16.2507 4.05007 16.1848 3.93279 16.0675C3.81552 15.9503 3.74963 15.7912 3.74963 15.6253C3.74963 15.4595 3.81552 15.3004 3.93279 15.1832L9.11639 10.0003L3.93279 4.81753C3.81552 4.70026 3.74963 4.5412 3.74963 4.37535C3.74963 4.2095 3.81552 4.05044 3.93279 3.93316C4.05007 3.81588 4.20913 3.75 4.37498 3.75C4.54083 3.75 4.69989 3.81588 4.81717 3.93316L9.99998 9.11675L15.1828 3.93316C15.3001 3.81588 15.4591 3.75 15.625 3.75C15.7908 3.75 15.9499 3.81588 16.0672 3.93316C16.1844 4.05044 16.2503 4.2095 16.2503 4.37535C16.2503 4.5412 16.1844 4.70026 16.0672 4.81753L10.8836 10.0003L16.0672 15.1832Z" fill="white"/>
    </svg>
    {{ filter.name }} <span *ngIf="filter.ObjectCount>0">{{filter.ObjectCount}}</span>
  </div>
</ng-template>

<ng-template #currentFilter let-currentFilter>
  <div class="subfilters-selector" *ngIf="currentFilter?.Children?.length>0">
    <div class="subfilters">
      <ng-container *ngFor="let subFilter of currentFilter.Children|sort:'name'">
        <div class="subfilter" [ngClass]="{'subfilter-width-children':subFilter?.Children?.length}">
          <ng-container *ngIf="subFilter && subFilter?.Children && subFilter?.Children?.length">
            <div class="subfilter-title subfilter-selectable"  (click)="addFilter(subFilter)">{{subFilter.name}} <span *ngIf="subFilter.ObjectCount>0">({{subFilter.ObjectCount}})</span></div>
            <div class="subfilter-list">
              <ng-container *ngFor="let sub2Filter of subFilter.Children|sort:'name'">
                <ng-container *ngTemplateOutlet="filterButtonAddTemplate; context:{$implicit: sub2Filter}"></ng-container>
                <ng-container *ngTemplateOutlet="filterButtonRemoveTemplate; context:{$implicit: sub2Filter}"></ng-container>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="subFilter && (!subFilter?.Children || !subFilter?.Children?.length)">
            <ng-container *ngTemplateOutlet="filterButtonAddTemplate; context:{$implicit: subFilter}"></ng-container>
            <ng-container *ngTemplateOutlet="filterButtonRemoveTemplate; context:{$implicit: subFilter}"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
